module.exports = __webpack_public_path__ + "static/media/1_en.61c9e1f9.png";